// extracted by mini-css-extract-plugin
export default {"introduction":"ExternalSignInView__introduction___1JVbX","blockHighlightBase":"ExternalSignInView__blockHighlightBase____8_RO"};